import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { LOGO_LIGHT } from "@/lib/content";

export default function Privacy() {
  const { t } = useLang();
  const p = t.legal.privacy;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-navy" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-5 md:px-10 py-32 md:py-40">
        <img src={LOGO_LIGHT} alt="La Rondine Charter" className="h-16 w-auto" />
        <h1 className="mt-10 font-serif font-light text-canvas text-4xl md:text-6xl leading-tight tracking-tight">
          {p.title}
        </h1>
        <p className="mt-3 text-sm text-canvas/50">{p.updated}</p>

        <div className="mt-12 space-y-10">
          {p.sections.map((s) => (
            <section key={s.h} data-testid="privacy-section">
              <h2 className="font-serif text-2xl md:text-3xl text-gold">{s.h}</h2>
              <p className="mt-3 font-light leading-relaxed text-canvas/75">{s.p}</p>
            </section>
          ))}
        </div>

        <Link
          to="/"
          data-testid="privacy-back-link"
          className="mt-16 inline-flex items-center gap-2 rounded-full border border-gold px-7 py-3 text-sm uppercase tracking-[0.15em] text-goldsoft transition-colors hover:bg-gold hover:text-navy"
        >
          <span aria-hidden="true">←</span> {p.back}
        </Link>
      </div>
    </main>
  );
}
